import { HubConnection } from '@microsoft/signalr'
import { AppDispatch } from '../types/store'
import { SignalRMethods } from './lib/SignalRMethods'
import { logOnSignalRMethodTrigger } from './lib/logOnSignalRMethodTrigger'
import { updateConfigHashMap } from '../store/actions/configurationActions'

export const receiveUpdatedConfigNotification = (
    connection: HubConnection,
    dispatch: AppDispatch
) => {

    connection.on(SignalRMethods.UPDATED_CONFIG_NOTIFICATION, (productId, hashMap) => {
        logOnSignalRMethodTrigger(
            SignalRMethods.UPDATED_CONFIG_NOTIFICATION,
            productId,
            hashMap
        )
        if (productId && hashMap) {
            dispatch(updateConfigHashMap(productId, hashMap))
        }
    })
}